import { PickupInfo } from "../reducers/shoppingCartOrder";
import { ShippingAddress } from "../reducers/uploadedBoard";
import { FlashPCBSettings } from "../utils/settings";

export const STRIPE_MINIMUM_PAYMENT = 1;

export const getPickupInfoAddress = (
  pickupInfo: PickupInfo,
  flashPCBSettings: FlashPCBSettings,
): ShippingAddress => {
  return {
    name: pickupInfo.name,
    company_name: pickupInfo.company_name || "",
    address_line_1: flashPCBSettings.flashpcb_address.street_address,
    city: flashPCBSettings.flashpcb_address.city,
    state: flashPCBSettings.flashpcb_address.state,
    postal_code: flashPCBSettings.flashpcb_address.zip,
    phone_number: pickupInfo.phone_number,
    email: pickupInfo.email,
    address_index: null,
  };
};

export const USD = "USD";
